export default "__VITE_ASSET__Qo7_ruhl__"